import { BROWSER_ROUTES } from "./browser.routes";

/** Guest auth screens: do not treat as “last visited” embed targets for post-login redirect. */
const AUTH_ENTRY_PATHS = new Set<string>([
	BROWSER_ROUTES.LOGIN,
	BROWSER_ROUTES.SIGNUP,
	BROWSER_ROUTES.SIGNUP_VERIFY_OTP,
	BROWSER_ROUTES.SIGNUP_RESET_PASSWORD,
	BROWSER_ROUTES.VERIFY_EMAIL,
	BROWSER_ROUTES.FORGET_PASSWORD,
	BROWSER_ROUTES.VERIFY_OTP,
	BROWSER_ROUTES.RESET_PASSWORD,
]);

export function isAuthEntryPath(pathname: string): boolean {
	return AUTH_ENTRY_PATHS.has(pathname);
}
